import React from 'react';
import { PAGE_HEIGHT, PAGE_WIDTH } from './templateLayout';

const TONES = {
  field: 'bg-purple-400/80',
  detail: 'bg-violet-300/90',
  text: 'bg-gray-400/90',
};

// The page in miniature for the Templates list: each box as a block of colour
// where it sits on the sheet, so templates on the same form can be told apart
// at a glance without opening them.
const TemplateThumbnail = ({ layout, width = 64 }) => {
  const scale = width / PAGE_WIDTH;
  const boxes = Array.isArray(layout?.boxes) ? layout.boxes : [];
  return (
    <span
      aria-hidden="true"
      className="relative block shrink-0 overflow-hidden rounded-sm bg-white shadow-md ring-1 ring-black/20"
      style={{ width, height: PAGE_HEIGHT * scale }}
    >
      {boxes.map((box) => (
        <span
          key={box.id}
          className={`absolute rounded-[1px] ${TONES[box.kind] || TONES.text}`}
          style={{
            left: box.x * scale,
            top: box.y * scale,
            width: Math.max(1, box.w * scale),
            height: Math.max(1, box.h * scale),
          }}
        />
      ))}
    </span>
  );
};

export default TemplateThumbnail;
